// -- todo - base service class
import { RealtimeClient } from "./RealtimeClient";
import { RestClient } from "./restClient";

export class ApplicationService {
	constructor(options) {
		this._options = options;
		this._rc = new RealtimeClient();
		this._restClient = new RestClient();
	}

	createApplication(app, callback) {
		const url = "/ecosystem/api/applications";
		const body = JSON.stringify({ application: app });
		this._restClient.exec_post(url, body, callback);
	}

	getAll(callback) {
		const url = "/ecosystem/api/applications";
		// If gets passed a callback, executes normally. Otherwise returns promise for use with async/await, etc.
		if (callback) {
			this._restClient.exec_get(url, callback);
		} else {
			return new Promise((resolve, reject) => {
				this._restClient.exec_get(url, (err, result) => {
					if (err) {
						reject(err);
						return;
					}
					resolve(result);
				});
			});
		}
	}

	getApplication(appId, callback) {
		const url = `/ecosystem/api/applications/${appId}`;
		this._restClient.exec_get(url, callback);
	}

	getApplicationOrgProfile(appId, orgId, callback) {
		const url = `/ecosystem/api/applications/${appId}/orgProfile/${orgId}`;
		this._restClient.exec_get(url, callback);
	}

	getApplicationVersion(app, callback) {
		const url = `/${app}/api/_appVersion`;
		if (callback) {
			this._restClient.exec_get(url, callback);
		} else {
			return new Promise((resolve, reject) => {
				this._restClient.exec_get(url, (err, result) => {
					if (err) {
						reject(err);
						return;
					}
					resolve(result);
				});
			});
		}
	}

	getApplicationConfig(callback) {
		const pathParts = window.location.href.split("/");

		// If pathParts[3] is login, call the callback with null result
		if (pathParts[3] === "login") {
			if (callback) {
				callback(null, null);
				return;
			} else {
				return Promise.resolve(null);
			}
		}

		const clientConfUrl = `${pathParts[0]}//${pathParts[2]}/${
			pathParts[3] ? `${pathParts[3]}/` : ""
		}api/_clientConfig`;

		if (callback) {
			this._restClient.exec_get(clientConfUrl, callback);
		} else {
			return new Promise((resolve, reject) => {
				this._restClient.exec_get(clientConfUrl, (err, result) => {
					if (err) {
						reject(err);
						return;
					}
					resolve(result);
				});
			});
		}
	}

	/**
	 * Get app specific map overlays
	 * @param {string} appId
	 * @param {function} callback
	 */
	getAppSpecificMapOverlays(appId, callback) {
		const url = `/ecosystem/api/applications/${appId}/mapOverlays`;
		this._restClient.exec_get(url, callback);
	}

	/**
	 * Create appMapOverlay
	 * @param {string} appId
	 * @param {Array} data
	 */
	createAppMapOverlay(appId, data, callback) {
		const url = `/ecosystem/api/applications/${appId}/mapOverlays`;
		const body = JSON.stringify({
			data
		});
		this._restClient.exec_put(url, body, callback);
	}

	/**
	 * delete AppMapOverlay
	 * @param {String} appid
	 * @param {String} overlayId
	 */
	deleteAppMapOverlay(appId, overlayId, callback) {
		const url = `/ecosystem/api/applications/${appId}/mapOverlays/${overlayId}`;
		this._restClient.exec_delete(url, callback);
	}
}
